import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CustomersService } from "../../../_services/customers.service";
import { ServiceAddonsService } from "../../../_services/serviceaddons.service";
import { ProlongingsAgreement } from "../../../_models/prolongings/prolongingsagreement";
import { ServiceAddon } from "../../../_models/serviceaddon";
import { Customer } from "../../../_models/customer";
import { Subscription } from "rxjs";
import { CookieService, CookieOptions } from 'ngx-cookie';
import {
  ToasterModule,
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { EnvironmentService } from "app/_services";
@Component({
  selector: "additional-products",
  templateUrl: "./additional-products.component.html",
  providers: [ServiceAddonsService, CustomersService],
})
export class ProlongingsAdditionalProductsComponent implements OnInit {
  private serviceaddons: ServiceAddon[];
  private customer: Customer;
  private customerid: string = "";
  private errorMessage: string = "";
  public isLoading: boolean = true;
  public calculatedPrice: number;
  private serviceaddonslist = [];
  public customer_data: Customer = new Customer();
  public agreement: ProlongingsAgreement;
  public prolongingsAgreement: ProlongingsAgreement;

  private subscription: Subscription;
  private cookieService: CookieService;
  private toasterService: ToasterService;
  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });
  public dealercalc: boolean;
  private showSearchByReg: boolean = true;
  constructor(
    toasterService: ToasterService,
    private customersService: CustomersService,
    private activatedRoute: ActivatedRoute,
    private serviceAddonsService: ServiceAddonsService,
    private environmentService: EnvironmentService,
    cookieService: CookieService
  ) {
    this.toasterService = toasterService;
    this.activatedRoute = activatedRoute;
    this.cookieService = cookieService;
  }
  ngOnInit() {
    this.isLoading = false;
    this.activatedRoute.params.subscribe((params) => {
      this.prolongingsAgreement = JSON.parse(sessionStorage.getItem("prolongingsAgree"));
      this.customerid = this.prolongingsAgreement.customer;
      this.calculatedPrice = this.prolongingsAgreement.price;
      this.dealercalc = params["dealercalc"] == "true";
      if (params["regsearch"] && params["regsearch"] == "false") {
        this.showSearchByReg = false;
      }
      this.customersService.read(this.customerid).subscribe(
        /* happy path */ (p) => (this.customer = p),
        /* error path */ (e) => (this.errorMessage = e),
        /* onComplete */ () => {
          this.serviceAddonsService
            .getDealer(this.customer.dealer[0]._id, "prolongings")
            .subscribe(
              /* happy path */ (p) => (this.serviceaddons = p),
              /* error path */ (e) => (this.errorMessage = e),
              /* onComplete */ () => {
                for (var i = 0; i < this.serviceaddons.length; i++) {
                  this.serviceaddons[i].selected = false;
                }
              }
            );
        }
      );
    });
  }
  calculatePrice() {
    let newPrice: number;
    newPrice = this.prolongingsAgreement.price;
    this.serviceaddonslist = [];
    for (var i = 0; i < this.serviceaddons.length; i++) {
      if (this.serviceaddons[i].selected) {
        newPrice += this.serviceaddons[i].price;
        this.serviceaddonslist.push(this.serviceaddons[i]);
      }
    }
    this.calculatedPrice = newPrice;
  }
  gotoCheckout(): void {
    this.prolongingsAgreement.addons = this.serviceaddonslist;
    this.prolongingsAgreement.price = this.calculatedPrice;
    sessionStorage.setItem("prolongingsAgree", JSON.stringify(this.prolongingsAgreement));
    top.window.location.href =
      "/#/prolongings/order-flow/checkout/" +
      this.customerid +
      "?regsearch=" +
      (this.showSearchByReg ? "true" : "false") +
      (this.dealercalc ? "&dealercalc=true" : "");
  }
  back() {
    window.history.back();
  }
}


// WEBPACK FOOTER //
// ./src/app/landingpages/prolongings/order-flow/additional-products.component.ts